export const SITE_URL = "https://www.taxby.io";

export const DEFAULT_SEO = {
  title: "Taxby | Asesoría fiscal con IA para autónomos",
  description:
    "Gestoría fiscal con inteligencia artificial para autónomos: OCR, asesor IA con normativa española, modelos 130/303 y VeriFactu. Únete a la lista de espera.",
  image: `${SITE_URL}/og-image.jpg`,
};

export type PageSeo = {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
};

export const pageSeoConfig: Record<string, PageSeo> = {
  "/": {
    title: DEFAULT_SEO.title,
    description: DEFAULT_SEO.description,
    path: "/",
  },
  "/terminos-condiciones": {
    title: "Términos y Condiciones | Taxby",
    description: "Términos y condiciones de uso de la plataforma Taxby para autónomos.",
    path: "/terminos-condiciones",
  },
  "/politica-privacidad": {
    title: "Política de Privacidad | Taxby",
    description: "Política de privacidad y tratamiento de datos personales en Taxby.",
    path: "/politica-privacidad",
  },
  "/politica-cookies": {
    title: "Política de Cookies | Taxby",
    description: "Información sobre el uso de cookies en el sitio web de Taxby.",
    path: "/politica-cookies",
  },
  "/declaracion-responsable": {
    title: "Declaración Responsable VERI*FACTU | Taxby",
    description:
      "Declaración responsable del sistema informático de facturación Taxby conforme al RD 1007/2023 y la Orden HAC/1177/2024.",
    path: "/declaracion-responsable",
  },
};
